<form>
	<ui-modal [modalTitle]="isCreatingTemplate ? (editingTemplate ? 'Edit Template' : 'New Template') : (id === 'new' ? 'New Report' : 'Report Details')" size="lg" [showCloseButton]="false" [easyClose]="false">
		<ng-container *ngIf="data && templates">
			<ng-container *ngIf="!templatedSelected ; else createReport">
				<div class="row">
					<div class="col-3 mt-2">
						<div class="d-flex align-items-center border-dotted hoverable justify-content-center border border-2 p-4 text-secondary selectable" (click)="selectTemplate(null, $event)">
							<div class="text-center w-100">
								<div class="text-large mb-1">
									<i class="wq wq-add text-secondary text-large"></i>
								</div>
								<div class="text-small">Start with a Blank Report</div>
							</div>
						</div>
					</div>
				</div>

				<div>
					<div class="d-flex align-items-center my-4">
						<div class="text-secondary text-bold mr-2 flex-weight-1">Or choose from the templates below</div>
						<button type="button" class="btn btn-primary" (click)="startCreateTemplate()">Create Template</button>
					</div>
					<div *ngIf="templates.length" class="scrollable-y px-1" style="max-height: 500px;">
						<div class="row">
							<div class="col-3 mt-2" *ngFor="let template of templates; let i = index">
								<div class="border border-dotted hoverable border-2 p-2 text-secondary selectable"  (click)="selectTemplate(template, $event)">
									<div class="d-flex justify-content-between">
										<div class="text-center w-100 pb-3 pt-3 pl-2">
											<div class="text-large mb-1">
												<i class="wq wq-page text-secondary text-large"></i>
											</div>
											<div class="text-small">{{template.template_name}}</div>
										</div>
										<div class="ml-1">
											<button class="btn btn-outline-secondary btn-sm border-0 px-1 dropdown-toggle" data-toggle="dropdown"><i class="wq wq-more"></i></button>
											<div class="dropdown-menu dropdown-menu-right" style="min-width: 0 !important; max-width: 150px; white-space: nowrap;">
												<button class="dropdown-item dropdown-item-primary" ngbTooltip="Edit Template" (click)="editTemplate(template); $event.stopPropagation();">
													<i class="wq wq-edit mr-2"></i>Edit
												</button>
												<button class="dropdown-item dropdown-item-primary" ngbTooltip="Delete Template" (click)="deleteTemplate(template); $event.stopPropagation();">
													<i class="wq wq-delete mr-2"></i>Delete
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div *ngIf="!templates.length" class="text-center text-secondary mt-2">
						No templates made yet.
					</div>
				</div>
			</ng-container>
			<ng-template #createReport>
				<ui-form labelWidth="7rem">
					<ng-container *ngIf="!task_id && !work_order_id && !isCreatingTemplate">
						<ng-container *ngIf="id !== 'new' ; else editTemplate">
							<ui-form-control label="Report Type">
								<div class="d-flex align-items-center">
									<button type="button" class="btn btn-sm mr-2 btn-primary" style="font-size: 0.7rem;">{{data.type === 'work_order' ? 'Job' : 'Task'}}</button>
								</div>
							</ui-form-control>
							<ui-form-control label="Task" *ngIf="data.type === 'task'">
								<div class="form-control bg-lightergrey h-auto">
									<div class="text-bold">{{data.task_name}}</div>
									<div class="text-small">{{data.project}}</div>
								</div>
							</ui-form-control>
							<ui-form-control label="Job" *ngIf="data.type === 'work_order'">
								<div class="form-control bg-lightergrey h-auto">
									<div class="text-bold">{{data.work_order_no}} {{data.work_order_name}}</div>
									<div class="text-small">{{data.project}}</div>
								</div>
							</ui-form-control>
						</ng-container>

						<ng-template #editTemplate>
							<ui-form-control label="Report Type">
								<div class="d-flex align-items-center">
									<ng-container *ngFor="let t of typTabs">
										<button type="button" class="btn btn-sm mr-2 {{typeColor(t)}} " (click)="typeChange(t.id)" style="font-size: 0.7rem;">{{t.description}}</button>
									</ng-container>
								</div>
							</ui-form-control>
							<ng-container *ngIf="data.type === 'work_order'">
								<ui-form-control label="Job">
									<div class="d-flex">
										<div class="form-control bg-lightergrey h-auto">
											<ng-container *ngIf="data.work_order">
												<div class="text-bold">{{data.work_order.work_order_no}} {{data.work_order.name}}</div>
												<div class="text-small">{{data.work_order.project}}</div>
											</ng-container>
											<div *ngIf="!data.work_order" class="text-secondary">No job selected.</div>
										</div>
										<button type="button" class="btn btn-outline-secondary px-2 ml-1" (click)="editSelectWorkOrder()" ngbTooltip="Select job"><i class="wq wq-search"></i></button>
										<button *ngIf="data.work_order" type="button" class="btn btn-outline-secondary px-2 ml-1" (click)="removeWorkOrder()" ngbTooltip="Remove job"><i class="wq wq-close"></i></button>
									</div>
								</ui-form-control>
							</ng-container>
							<ng-container *ngIf="data.type === 'task'">
								<ui-form-control label="Task">
									<div class="d-flex">
										<div class="form-control bg-lightergrey h-auto">
											<ng-container *ngIf="data.task">
												<div class="text-bold">{{data.task.name}}</div>
												<div class="text-small">{{data.task.project}}</div>
											</ng-container>
											<div *ngIf="!data.task" class="text-secondary">No task selected.</div>
										</div>
										<button type="button" class="btn btn-outline-secondary px-2 ml-1" (click)="editSelectTask()" ngbTooltip="Select task"><i class="wq wq-search"></i></button>
										<button *ngIf="data.task" type="button" class="btn btn-outline-secondary px-2 ml-1" (click)="removeTask()" ngbTooltip="Remove task"><i class="wq wq-close"></i></button>
									</div>
								</ui-form-control>
							</ng-container>
						</ng-template>
					</ng-container>

					<ui-form-control label="Name">
						<input class="form-control" [(ngModel)]="data.name" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off" appAutoFocus>
					</ui-form-control>

					<ui-form-control label="Content">
						<div class="border border-lightgrey rounded selectable px-2 py-1 edit-content-container hover-parent" (click)="editContent('content')">
							<button type="button" class="btn btn-primary edit-content-button hover-child"><i class="wq wq-edit mr-1"></i>Edit Content</button>
							<div *ngIf="!data.content" class="text-secondary">Content</div>
							<div *ngIf="data.content" [innerHtml]="data.content | safeHtml" style="pointer-events: none;"></div>
						</div>
					</ui-form-control>
				</ui-form>
			</ng-template>
		</ng-container>

		<button *ngIf="!isCreatingTemplate && data?.id !== 'new'" type="button" class="btn btn-danger" (click)="delete()" [disabled]="disabled" ui-modal-footer>Delete</button>
		<div class="flex-weight-1" ui-modal-footer></div>
		<button type="button" class="btn btn-medium" (click)="onCancel()" [disabled]="disabled" ui-modal-footer>Cancel</button>
		<button *ngIf="templatedSelected && !isCreatingTemplate" type="submit" class="btn btn-primary" (click)="save()" [disabled]="disabled" ui-modal-footer>Save</button>
		<button *ngIf="templatedSelected && isCreatingTemplate" type="button" class="btn btn-primary" (click)="saveTemplate()" [disabled]="disabled" ui-modal-footer>Save Template</button>
	</ui-modal>
</form>

<modal-edit-content (close)="editContentModalClosed($event)"></modal-edit-content>
<modal-select-work-order (close)="editSelectWorkOrderModalClosed($event)"></modal-select-work-order>
<modal-select-task (close)="editSelectTaskModalClosed($event)"></modal-select-task>
